export default __webpack_public_path__ + "static/media/033-razor.167c77bd.svg";